import React from "react";
import { HiArrowUpRight } from "react-icons/hi2";

export default function CTA() {
  return (
    <div className="bg-slate-100 py-24 sm:pt-32 pb-40">
      <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <img src="./img/term.png" className="mx-auto" alt="" />
          <p className="hidden sm:block sm:text-7xl lg:text-8xl mt-2 mx-auto max-w-3xl font-extrabold text-center tracking-tight leading-tight text-gray-800 ">
            สนใจเรียนกับเรา?<br/>ติดต่อเลย
          </p>
          <p className="sm:hidden mt-2 mx-auto max-w-3xl text-5xl font-extrabold text-center tracking-tight leading-tight text-gray-800 sm:text-8xl">
            สนใจเรียน?<br/>ติดต่อเลย
          </p>
          <a
            href="https://liff.line.me/1645278921-kWRPP32q/?accountId=galileo_tutor"
            target="_blank"
          >
            <p className=" font-bold text-2xl text-white p-5 text-center bg-lime-500 w-[200px] mx-auto mt-10 leading-tight border border-lime-500 ease-in-out duration-200 hover:bg-slate-100 hover:text-lime-500 ">
              สมัครเรียน &nbsp;
              <HiArrowUpRight className="inline" />
            </p>
          </a>
        </div>
      </div>
    </div>
  );
}
